import Home from "@/pages/Home";
import Search from "@/pages/Search";
import Product from "@/pages/Product";
import ProductDetails from "@/pages/ProductDetails";
import Trend from "@/pages/Trends";
import TrendDetails from "@/pages/TrendDetails";
import SuccessStories from "@/pages/SuccessStories";
import Blog from "@/pages/Blog";
import BlogDetails from "@/pages/BlogDetails";
import SignUp from "@/pages/SignUp";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import EmailVerify from "@/pages/EmailVerify";
import VerifyOtp from "@/pages/VerifyOtp";
import ResetPassword from "@/pages/ResetPassword";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Faq from "@/pages/Faq";
import Dropshipping from "@/pages/Dropshipping";
import Term from "@/pages/Term";

const routes = [
	{
		id: "home",
		path: "/",
		element: <Home />,
	},
	{
		id: "search",
		path: "/search",
		element: <Search />,
	},
	{
		id: "products",
		path: "/products",
		children: [
			{
				id: "products-list",
				index: true,
				element: <Product />,
			},
			{
				id: "product-details",
				path: ":productId",
				element: <ProductDetails />,
			},
		],
	},
	{
		id: "trends",
		path: "/trends",
		children: [
			{
				id: "trend-list",
				index: true,
				element: <Trend />,
			},
			{
				id: "trend-details",
				path: ":trendId",
				element: <TrendDetails />,
			},
		],
	},
	{
		id: "success-stories",
		path: "/success-stories",
		element: <SuccessStories />,
	},
	{
		id: "blog",
		path: "/blog",
		element: <Blog />,
	},
	{
		id: "blog-details",
		path: "/blog-details",
		element: <BlogDetails />,
	},
	{
		id: "sign-up",
		path: "/sign-up",
		element: <SignUp />,
	},

	{
		id: "login",
		path: "/login",
		element: <Login />,
	},
	{
		id: "forgot-password",
		path: "/forgot-password",
		element: <ForgotPassword />,
	},
	{
		id: "verify-otp",
		path: "/verify-otp",
		element: <VerifyOtp />,
	},
	{
		id: "email-verify",
		path: "/email-verify",
		element: <EmailVerify />,
	},
	{
		id: "reset-password",
		path: "/reset-password",
		element: <ResetPassword />,
	},
	{
		id: "privacy",
		path: "/privacy",
		element: <PrivacyPolicy />,
	},
	{
		id: "faq",
		path: "/faq",
		element: <Faq />,
	},
	{
		id: "dropshipping",
		path: "/dropshipping",
		element: <Dropshipping />,
	},
	{
		id: "terms",
		path: "/terms",
		element: <Term />,
	},
];

export default routes;
